import { VehicleReserves } from "./VehicleReserves";
import { ReusableVehicles } from "./ReusableVehicles";

export class VehiclePool{

    reserves: VehicleReserves;
    reusables:ReusableVehicles;
    
    constructor(reserves:VehicleReserves,reusables:ReusableVehicles){

        this.reserves = reserves;
        this.reusables = reusables;
    }
}